import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogService } from 'app/dialogs/dialog.service';
import { ChatMessageItem } from 'app/models/chat-message-item.model';
import { ChatMessageData } from 'app/models/comment.model';
import { UserModel } from 'app/models/user.model';
import { AuthService } from 'app/services/auth.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class CommentsComponent implements OnInit {
  @Input() canAddComment: boolean;
  @Input() consultationId: number;
  @Input() sectionTypeId: number;
  @Input() maxLength = 4096;
  @Input() expanded: boolean = true;

  commentList: ChatMessageItem[];
  dataLoading: boolean;

  readonly CHAT_SORT_ORDER_TOKEN = 'internal_chat_sort_order';
  chatOrderAscending: boolean;

  @Input() postFunction: (chatMessageData: ChatMessageData) => Observable<ChatMessageItem>;
  @Input() getFunction: (consultationId: number, sectionTypeId: number) => Observable<ChatMessageItem[]>;

  @Output() onError: EventEmitter<boolean> = new EventEmitter();

  commentForm: UntypedFormGroup;
  user: UserModel;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private auth: AuthService
  ) {
    this.user = auth.currentUser;
  }

  ngOnInit(): void {
    this.chatOrderAscending = JSON.parse(MVLocalStorageService.getItem(this.CHAT_SORT_ORDER_TOKEN) === null ?
      'true' :
      MVLocalStorageService.getItem(this.CHAT_SORT_ORDER_TOKEN)
    );

    this.commentForm = this.formBuilder.group({
      comment: ['', Validators.maxLength(this.maxLength)]
    });
    this.getComments();
  }

  validateDataLoading() {
    return this.dataLoading;
  }

  getComments() {
    this.dataLoading = true;
    this.getFunction(this.consultationId, this.sectionTypeId).subscribe({
      next: result => {
        this.commentList = result;
        this.sortMessages();
        this.dataLoading = false;
      },
      error: () => {
        this.dataLoading = false;
        this.onError.emit(true);
      }
    });
  }

  add(value) {
    if (!this.commentForm.invalid) {
      this.dataLoading = true;
      const chatMessage: ChatMessageData = {
        consultationId: this.consultationId,
        consultationSectionTypeId: this.sectionTypeId,
        message: value
      };
      this.postFunction(chatMessage)
        .subscribe({
          next: result => {
            this.dataLoading = false;
            if (result) {
              this.commentForm.reset();
              const commentResult = result as ChatMessageItem;
              this.commentList.push(commentResult);
              this.sortMessages();
            }
          },
          error: () => {
            this.dataLoading = false;
            this.onError.emit(true);
          }
        });
    }
  }

  toogleChatOrder() {
    this.chatOrderAscending = !this.chatOrderAscending;
    this.sortMessages();

    MVLocalStorageService.setItem(this.CHAT_SORT_ORDER_TOKEN, this.chatOrderAscending);
  }

  sortMessages() {
    const sortByDate = this.chatOrderAscending ?
      ((x, y) => x.date > y.date ? 1 : -1) :
      ((x, y) => x.date < y.date ? 1 : -1);
    this.commentList = this.commentList.sort((x, y) => sortByDate(x, y));
  }

}
